<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>صادر المخزن</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع الأرصدة الصادرة للمخزن
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
                <ul>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='orm-group col-lg-3 col-md-4 col-sm-6'>
                <h4 >الفرع:</h4>
                <select  style="padding: 0px" class="form-control" v-model="branch">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
              </div>
              <div class='orm-group col-lg-3 col-md-4 col-sm-6' style='padding: 38px 0px 0px 15px;'>
                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block'>عرض</button>
              </div>
              <!-- /.panel-heading -->
              <div class='panel-body'>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الصنف</th>
                      <th style='text-align: center'>الكمية</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>

                      <td align='center'>{{index+1}}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>{{record.x_count}}</td>
                    </tr>
                  </tbody>
                </table>
                <!-- /.table-responsive -->
              </div>
              <!-- /.panel-body -->
            </div>
            <!-- /.panel -->
          </div>
          <!-- /.col-lg-12 -->
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import moment from 'moment'
export default {
  name: 'IncomingStore',
  components: {
    tbDate
  },
  data () {
    return {
      validationErrors: '',
      records: {},
      branches: [],
      branch: '',
      today: true,
      errorShow: false,
      isLoadingData: false,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: ''
    }
  },
  created () {
    this.branch = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    GetData () {
      this.validationErrors = []
      var isError = false
      if (!moment(this.from_date, 'YYYY-MM-DD', true).isValid()) {
        this.validationErrors.push('يجب ادخال التاريخ من بطريقه صحيحة')
        isError = true
      }
      if (!moment(this.to_date, 'YYYY-MM-DD', true).isValid()) {
        this.validationErrors.push('يجب ادخال التاريخ الى بطريقه صحيحة')
        isError = true
      }
      if (isError === true) {
        return
      }
      this.validationErrors = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'incoming-store', {
        token: localStorage.getItem('token'),
        branche_id: this.branch,
        from_date: this.from_date,
        to_date: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/IncomingStore.vue